import { createFileRoute } from "@tanstack/react-router";
import { SuperuserInvitePage } from "@/features/superuser/invites/superuser-invite.page";

export const Route = createFileRoute("/_authenticated/superuser/invites")({
  component: SuperuserInvitePage,
});
